import "./../../../components/view-models/bao-color-picker";
import Bao from "./../../../services/bao-service";
import * as ko from "knockout";
import TabPage from "./../../../factories/tab-page";
import BaoDialog from "./../../../factories/bao-dialog";
import imageResizeDialogTemplate from "./../../factories/image-resize-dialog-template.html";
import ImageResizeDialog from "./image-resize-dialog";


class TakePictureDialog {
    Bao = Bao;
    Video: HTMLVideoElement;
    VideoStream: MediaStream;
    Canvas: HTMLCanvasElement;
    CanvasContext: CanvasRenderingContext2D;
    CanvasContainer: HTMLDivElement;
    Textarea: HTMLTextAreaElement;
    TmpTextContainer: HTMLDivElement;
    CameraOn: KnockoutObservable<boolean> = ko.observable(false);
    EditDrawMode: KnockoutObservable<boolean> = ko.observable(true);
    Colors: KnockoutObservableArray<string> = ko.observableArray(["#ff0000", "#ff6600", "#ffff00", "#009900", "#00ff00", "#00ccff", "#0000ff", "#9900cc", "#ff00ff", "#ffffff", "#888888", "#000000"]);
    SelectedColor: KnockoutObservable<string> = ko.observable("#ff0000");
    FontSizes: KnockoutObservableArray<number> = ko.observableArray([3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 22, 24, 26, 28, 30]);
    SelectedFontSize: KnockoutObservable<number> = ko.observable(10);
    MediaContainerSize: {
        width: number;
        height: number;
    } = { width: 800, height: 600 };
    TextareaCoordinates: {
        x: number;
        y: number;
    } = { x: 0, y: 0 };
    LastMouse: {
        x: number;
        y: number;
    } = { x: 0, y: 0 };
    MousePressed: boolean = false;
    PictureCopy: string;

    ImageFile: any;
    SelectedImageFormat: string;

    constructor() {
        
        this.EditDrawMode.subscribe(() => {
            this.removeTextArea();
            if (this.EditDrawMode()) {
                this.AddEventListenersForDrawing();
            }
            else {
                this.AddEventListenersForTextWriting();
            }
        });
        this.SelectedFontSize.subscribe(() => {
            if (this.Textarea) {
                this.Textarea.style.fontSize = this.SelectedFontSize() + "px";
            }
        });
    }
    InitDialog(base64Picture: string) {
        let mediaContainer = document.getElementById("media-container") as HTMLDivElement;
        this.CanvasContainer = document.getElementById("canvas-container") as HTMLDivElement;
        this.Canvas = document.getElementById("canvas") as HTMLCanvasElement;
        this.CanvasContext = this.Canvas.getContext("2d");
        this.TmpTextContainer = document.getElementById("tmp-text-container") as HTMLDivElement;
        this.Video = document.getElementById("video") as HTMLVideoElement;
        mediaContainer.style.width = this.MediaContainerSize.width + "px";
        mediaContainer.style.height = this.MediaContainerSize.height + "px";
        this.Canvas.width = this.Video.width = this.MediaContainerSize.width;
        this.Canvas.height = this.Video.height = this.MediaContainerSize.height;
        if (base64Picture) {
            this.PictureCopy = base64Picture;
            this.loadPicture(base64Picture, true, false);
        }
        else {
            this.CanvasContext.fillStyle = "white";
            this.CanvasContext.fillRect(0, 0, this.Canvas.width, this.Canvas.height);
        }
        this.AddEventListenersForDrawing();
    }
    AddEventListenersForDrawing = () => {
        this.RemoveEventListenersForTextWriting();
        ["mousedown", "touchstart"].forEach(event => this.Canvas.addEventListener(event, this.OnMouseDownForDrawing));
        ["mousemove", "touchmove"].forEach(event => this.Canvas.addEventListener(event, this.OnMouseMoveForDrawing));
        ["mouseup", "mouseleave", "touchend"].forEach(event => this.Canvas.addEventListener(event, this.OnMouseUpAndMouseLeaveForDrawing));
    };
    RemoveEventListenersForDrawing = () => {
        ["mousedown", "touchstart"].forEach(event => this.Canvas.removeEventListener(event, this.OnMouseDownForDrawing));
        ["mousemove", "touchmove"].forEach(event => this.Canvas.removeEventListener(event, this.OnMouseMoveForDrawing));
        ["mouseup", "mouseleave", "touchend"].forEach(event => this.Canvas.removeEventListener(event, this.OnMouseUpAndMouseLeaveForDrawing));
    };
    OnMouseDownForDrawing = (e) => {
        e.preventDefault();
        this.setOffsetValuesForMobile(e);
        this.MousePressed = true;
        this.DrawOnPicture(e.offsetX, e.offsetY, false);
    };
    OnMouseMoveForDrawing = (e) => {
        e.preventDefault();
        this.setOffsetValuesForMobile(e);
        if (this.MousePressed) {
            this.DrawOnPicture(e.offsetX, e.offsetY, true);
        }
    };
    OnMouseUpAndMouseLeaveForDrawing = (e) => {
        e.preventDefault();
        this.MousePressed = false;
    };
    DrawOnPicture = (x: number, y: number, isDown: boolean) => {
        if (isDown) {
            this.CanvasContext.beginPath();
            this.CanvasContext.strokeStyle = this.SelectedColor();
            this.CanvasContext.lineWidth = this.SelectedFontSize();
            this.CanvasContext.lineJoin = "round";
            this.CanvasContext.moveTo(this.LastMouse.x, this.LastMouse.y);
            this.CanvasContext.lineTo(x, y);
            this.CanvasContext.closePath();
            this.CanvasContext.stroke();
        }
        this.LastMouse.x = x;
        this.LastMouse.y = y;
    };
    AddEventListenersForTextWriting = () => {
        this.RemoveEventListenersForDrawing();
        ["mousedown", "touchstart"].forEach(event => this.Canvas.addEventListener(event, this.OnMouseDownForTextWriting));
        ["mousemove", "touchmove"].forEach(event => this.Canvas.addEventListener(event, this.OnMouseMoveForTextWriting));
        ["mouseup", "mouseleave", "touchend"].forEach(event => this.Canvas.addEventListener(event, this.OnMouseUpAndMouseLeaveForTextWriting));
    };
    RemoveEventListenersForTextWriting = () => {
        ["mousedown", "touchstart"].forEach(event => this.Canvas.removeEventListener(event, this.OnMouseDownForTextWriting));
        ["mousemove", "touchmove"].forEach(event => this.Canvas.removeEventListener(event, this.OnMouseMoveForTextWriting));
        ["mouseup", "mouseleave", "touchend"].forEach(event => this.Canvas.removeEventListener(event, this.OnMouseUpAndMouseLeaveForTextWriting));
    };
    OnMouseDownForTextWriting = (e) => {
        e.preventDefault();
        this.MousePressed = true;
        if (!this.Textarea) {
            this.setOffsetValuesForMobile(e);
            this.CreateTextArea(e);
        }
        else {
            this.WriteTextOnPicture();
            this.removeTextArea();
        }
    };
    OnMouseMoveForTextWriting = (e) => {
        e.preventDefault();
        if (this.MousePressed && this.Textarea) {
            this.setOffsetValuesForMobile(e);
            let width = e.offsetX - this.TextareaCoordinates.x;
            let height = e.offsetY - this.TextareaCoordinates.y;
            this.Textarea.style.left = (width < 0 ? this.TextareaCoordinates.x + width : this.TextareaCoordinates.x) + "px";
            this.Textarea.style.top = (height < 0 ? this.TextareaCoordinates.y + height : this.TextareaCoordinates.y) + "px";
            this.Textarea.style.width = Math.abs(width) + "px";
            this.Textarea.style.height = Math.abs(height) + "px";
        }
    };
    OnMouseUpAndMouseLeaveForTextWriting = (e) => {
        e.preventDefault();
        this.MousePressed = false;
        if (this.Textarea) {
            var width = parseInt(this.Textarea.style.width.replace("px", ""));
            var height = parseInt(this.Textarea.style.height.replace("px", ""));
            if (width < 10) {
                this.Textarea.style.width = this.SelectedFontSize() * 10 + "px";
            }
            if (height < 10) {
                this.Textarea.style.height = "";
            }
            this.Textarea.style.pointerEvents = "auto";
            this.Textarea.focus();
        }
    };
    CreateTextArea = (e) => {
        this.Textarea = document.createElement("textarea") as HTMLTextAreaElement;
        this.TextareaCoordinates.x = e.offsetX;
        this.TextareaCoordinates.y = e.offsetY;
        this.Textarea.style.top = e.offsetY + "px";
        this.Textarea.style.left = e.offsetX + "px";
        this.Textarea.style.padding = "0px";
        this.Textarea.style.width = "0px";
        this.Textarea.style.height = "0px";
        this.Textarea.style.lineHeight = "100%";
        this.Textarea.style.fontSize = this.SelectedFontSize() + "px";
        this.Textarea.style.color = this.SelectedColor();
        this.Textarea.style.borderColor = "white";
        this.Textarea.style.background = "transparent";
        this.Textarea.style.position = "absolute";
        this.Textarea.style.pointerEvents = "none";
        this.CanvasContainer.appendChild(this.Textarea);
    };
    WriteTextOnPicture = () => {
        let lines = this.Textarea.value.split("\n");
        let processedLines = [];
        for (let i = 0; i < lines.length; i++) {
            let chars = lines[i].length;
            for (let j = 0; j < chars; j++) {
                let textNode = document.createTextNode(lines[i][j]);
                this.TmpTextContainer.appendChild(textNode);
                this.TmpTextContainer.style.position = "absolute";
                this.TmpTextContainer.style.visibility = "hidden";
                this.TmpTextContainer.style.display = "block";
                let width = this.TmpTextContainer.offsetWidth;
                this.TmpTextContainer.style.position = "";
                this.TmpTextContainer.style.visibility = "";
                this.TmpTextContainer.style.display = "none";
                if (width > parseInt(this.Textarea.style.width)) {
                    break;
                }
            }
            processedLines.push(this.TmpTextContainer.textContent);
            this.TmpTextContainer.innerHTML = "";
        }
        let textareaStyle = getComputedStyle(this.Textarea);
        let fontSize = textareaStyle.getPropertyValue("font-size");
        let fontFamily = textareaStyle.getPropertyValue("font-family");
        this.CanvasContext.font = fontSize + " " + fontFamily;
        this.CanvasContext.textBaseline = "top";
        this.CanvasContext.fillStyle = this.SelectedColor();
        for (let n = 0; n < processedLines.length; n++) {
            this.CanvasContext.fillText(processedLines[n], parseInt(this.Textarea.style.left), parseInt(this.Textarea.style.top) + n * parseInt(fontSize));
        }
    };
    onClickDraw = () => {
        this.EditDrawMode(true);
    };
    onClickText = () => {
        this.EditDrawMode(false);
    };
    OpenCamera = () => {
        navigator.mediaDevices.getUserMedia({ video: { facingMode: 'user' } }).then(stream => {
            try {
                this.Video.srcObject = this.VideoStream = stream;
                this.Video.width = this.MediaContainerSize.width;
                this.Video.height = this.MediaContainerSize.height;
            }
            catch (error) {
                this.Video.src = window.URL.createObjectURL(stream);
            }
            this.Video.play();
            this.CameraOn(true);
        });
    };
    CloseCamera = () => {
        this.Video.pause();
        this.VideoStream.getTracks()[0].stop();
        this.CameraOn(false);
    };
    TakePicture = () => {
        this.PictureCopy = "";
        this.RefreshPicture();

        //Convert image to base64 string
        let canvasBase64 = document.createElement('canvas');
        canvasBase64.height = this.MediaContainerSize.height;
        canvasBase64.width = this.MediaContainerSize.width;
        let ctx = canvasBase64.getContext('2d');
        ctx.drawImage(this.Video, 0, 0, canvasBase64.width, canvasBase64.height);
        this.PictureCopy = canvasBase64.toDataURL();
        this.loadPicture(this.PictureCopy, false, true);

        this.CloseCamera();
    };
    FileChange = (element: any) => {
        let url = URL.createObjectURL(element.files[0]);
        this.ImageFile = element.files[0];

        this.PictureCopy = url;
        this.loadPicture(url, false, false);
        element.value = null;
    };
    RefreshPicture = () => {
        if (this.PictureCopy) {
            this.loadPicture(this.PictureCopy, true, false);
        }
        else {
            this.CanvasContext.clearRect(0, 0, this.Canvas.width, this.Canvas.height);
        }
    };

    private loadPicture = (src: string, isRefresh: boolean, isCameraImage: boolean) => {
        
        let image = new Image();
        image.onload = () => {

            if (isRefresh) {
                this.removeTextArea();
                this.Canvas.width = image.width ;
                this.Canvas.height = image.height;
                this.CanvasContainer.style.width = this.Canvas.width + "px";
                this.CanvasContext.drawImage(image, 0, 0, this.Canvas.width, this.Canvas.height);
            }
            else {

                //Image resize popup
                let imageSize: { height: number, width: number } = { height: image.height, width: image.width };
                let imageResizeDialog = new BaoDialog(Bao.Session.GetMessage("imageResizeDialogTitle"), imageResizeDialogTemplate);
                imageResizeDialog.ViewModel(new ImageResizeDialog(imageSize));
                imageResizeDialog.Open();
                imageResizeDialog.Width(480);
                imageResizeDialog.Buttons([
                    new BaoDialog.ButtonFactory(imageResizeDialog, Bao.Session.GetMessage("msgCancel"), () => {
                        imageResizeDialog.Close();
                    }),
                    new BaoDialog.ButtonFactory(imageResizeDialog, Bao.Session.GetMessage("msgOk"), () => {
                        imageResizeDialog.Close();

                        let imageSrc = isCameraImage ? src : this.ImageFile;
                        imageResizeDialog.ViewModel().ImageResize(imageSrc, (resultBase64String: string) => {

                            let resultImage = new Image();
                            resultImage.onload = () => {
                                this.removeTextArea();
                                this.Canvas.width = resultImage.width;
                                this.Canvas.height = resultImage.height;
                                this.CanvasContainer.style.width = this.Canvas.width + "px";
                                this.CanvasContext.drawImage(resultImage, 0, 0, this.Canvas.width, this.Canvas.height);

                                this.SelectedImageFormat = imageResizeDialog.ViewModel().SelectedImageFormat();
                                this.Canvas.toBlob((blob) => {
                                    this.PictureCopy = URL.createObjectURL(blob);
                                }, "image/" + this.SelectedImageFormat);
                            }
                            resultImage.src = resultBase64String;
                        });
                    })
                ]);
            }
        };


        image.src = src;
    };
    private setOffsetValuesForMobile = (e) => {
        if ((e.offsetX === undefined || e.offsetY === undefined) && e.touches.length > 0) {
            let offset = e.touches[0].target.getBoundingClientRect();
            e.offsetX = e.touches[0].pageX - offset.left;
            e.offsetY = e.touches[0].pageY - offset.top;
        }
    };
    private removeTextArea = () => {
        if (this.Textarea) {
            this.Textarea.parentNode.removeChild(this.Textarea);
            this.Textarea = null;
        }
    };

}
export default TakePictureDialog;